import { isFullWidth } from './isFullWidth';

export default function splitIntoSections(amp) {
  return function (bodyArray) {
    let wasFW = null;

    return bodyArray.reduce((sections, item) => {
      if (!item) return sections;

      const isFW = isFullWidth(item, amp);
      if ((isFW && !wasFW) || (!isFW && wasFW)) {
        // Add a new section if:
        // - item is full width and previous item was not, or
        // - item is not full width and previous item was.
        sections.push([item]);
      } else {
        // Combine full width and not full width items separately.
        const lastI = sections.length - 1;
        sections[lastI].push(item);
      }

      // Remember
      wasFW = isFW;

      return sections;
    }, [[]]); // set up with the first section (subarray) already in place
  };
}
